// Libraries
import styled from "styled-components"


export const DiscardChangesDialogContainer = styled.div`

`

